export default __webpack_public_path__ + "static/media/header-bg.d6b5eff8.png";